import type { FaireProductEntity } from "../../entity_types/product";

export const p_upntm9d8kq: FaireProductEntity = {
  token: "p_upntm9d8kq",
  type: "product",
  name: "10\" Ring Light with Stand",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/fcffb64dd8fc24e79bdf139d91479d38e66030d437112f0c8e2f7fb2bc8e9d6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0925f3963f564107b9ae022c0fdc810736af2b04487fd4d59db1adaf3a7c522.jpeg",
    "https://cdn.faire.com/fastly/03923a05dd61d595b4aa01607c25e1b50be7d0d25edc49d073ba3cf8c4f2e732.jpeg",
    "https://cdn.faire.com/fastly/b3d8069d45169db125b5434509a014bf29b9c7ac0cf350ca1c3b35e17dca3528.jpeg",
    "https://cdn.faire.com/fastly/307d1da9d6cc3df402e0e2c76caf183322b4649b342a83d90e7f8e141c6d608c.jpeg",
    "https://cdn.faire.com/fastly/3b4f7541e6ca1689a0470c8f3eb87d380a081550e3095b1859ed9cbe4f524d23.jpeg",
    "https://cdn.faire.com/fastly/393b846f49babb3fd99e38fe4af3198cfd0768eb687b18e697719f6aa45e7063.jpeg",
    "https://cdn.faire.com/fastly/0f4a5d903db1d3d4e0179c2aa1ed670dd77e09e944b4286d8e75abac571ea008.jpeg",
    "https://cdn.faire.com/fastly/9b52bf8f5f1a91c6f88f0fb05a6b68709b7b8af39790cb1565536715a32f37d5.jpeg",
    "https://cdn.faire.com/fastly/5fe4accc7a9721fcf77736cfacf74fb871c4f633714cd1d534f3850b16f9c4b9.jpeg"
  ],
  priceDollars: 24.99,
  description: "A compact 10\" ring light with an adjustable stand for product photos, videos and social content. The circular light gives bright, even illumination that helps reduce harsh shadows.\n\n- 10\" diameter ring light\n- Adjustable stand to set height and angle\n- Compact design for easy setup and storage\n\nA simple lighting setup for online listings, social media and promotional images.",
  tags: [],
  msrpDollars: 37.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:18.875Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
